export default "__VITE_ASSET__C5HOsv4j__"